<template>
    <div class="admin-footer" id="main-footer">
        <div class="page-loader-wrapper loading-container" style="display: none;">
            <div class="loading">
                <img src="/static/images/loading.gif">
            </div>
        </div>
        © {{system_year}} Velocity Vehicle Group. All Rights Reserved.
    </div>
</template>
<script>
    import Vue from 'vue';
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from '../event-bus';
    import moment from 'moment';
    import {HTTP} from '../../http-common';

    var self;
    export default {
        name: 'Footer',
        mixins: [commonMixins],
        components: {

        },
        data() {
            return {
                system_year: '',
            }
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            //self.getUserRole();
            self = this;

            var date = new Date();
            self.system_year = moment(date).format('YYYY');
           // self.getSystemYear();

            var userObj = localStorage.getItem("user_obj");
            //if user logged in than remove login button and registration button
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                // EventBus.$emit("login-user-info", true, userJson["email"], userJson["first_name"], userJson["last_name"]);
            }
        },
        methods: {
            getSystemYear() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                HTTP.get("get/systemyear", config)
                    .then(function (data) {

                        if (data.status == 200) {
                            self.system_year = data.data.content;
                        }
                    })
                    .catch(function (error) {

                        if (error.response.status == 0) {
                            self.error_msg_login = "Remote server can not be reachable";
                        } else {
                            if (error.response.data.message) {
                                self.error_msg_login = error.response.data.message;
                            }
                        }
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue